import Preview from './Preview.container'

export default Preview
